import { Suspense, lazy } from 'react';
import LoadingScreen from '../components/loading-screen';

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

export const LoginPage = Loadable(lazy(() => import('../pages/LoginPage')));
export const LoginQuickPage = Loadable(lazy(() => import('../pages/LoginQuickPage')));

export const PageStart = Loadable(lazy(() => import('../pages/Start')));

export const PageTournamentsParticipants = Loadable(lazy(() => import('../pages/Tournament/Participants')));
export const PageTournamentsParticipant = Loadable(lazy(() => import('../pages/Tournament/Participant')));

export const Page404 = Loadable(lazy(() => import('../pages/Page404')));
export const Page500 = Loadable(lazy(() => import('../pages/Page500')));
export const Page403 = Loadable(lazy(() => import('../pages/Page403')));
